// Avoid `console` errors in browsers that lack a console.
(function () {
  "use strict";

  let method;
  const noop = function () {
  };
  const methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
  ];
  let length = methods.length;
  const console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
}());

const Popper = window.Popper = require('popper.js').default;
const $ = window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('bootstrap4-toggle');
const Isotope = require('isotope-layout');
require('isotope-cells-by-row');
require('isotope-fit-columns');

(function () {
  "use strict";

  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top)
        }, 1000);
        return false;
      }
    }
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function () {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#sideNav'
  });

  (() => {
    let gridPortfolio = document.querySelector('.grid');
    let isoPortfolio = new Isotope(gridPortfolio, {
    //  layoutMode: 'cellsByRow'
    });
  })();

  (() => {
    let gridDev = document.querySelector('.dev-icons');
    let isoDev = new Isotope(gridDev);

    $(function () {
      $('#toggle-details').change(function () {
        $('#console-event').html('Toggle: ' + $(this).prop('checked'))
        if ($(this).prop('checked')) {
          $(gridDev).addClass('details');
          isoDev.arrange({
            //'layoutMode': 'fitColumns'
            'columnWidth': 300
          });
        } else {
          $(gridDev).removeClass('details');
          isoDev.arrange({
           // 'layoutMode': 'fitRows'
            'columnWidth': 72
          });
        }
      })
    })
  })();


})(); // End of use strict
